<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.51" height="21.49" viewBox="0 0 21.51 21.49">
    <g transform="translate(-1174.25 -674.25)">
      <path :style="{stroke:color}" class="a" d="M10,13a5,5,0,0,0,7.54.54l3-3a5,5,0,1,0-7.071-7.071L11.75,5.18"
            transform="translate(1173.005 672.995)"/>
      <path :style="{stroke:color}" class="a" d="M14,11a5,5,0,0,0-7.54-.54l-3,3a5,5,0,1,0,7.071,7.071L12.24,18.82"
            transform="translate(1173.005 672.995)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CooperationIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #3e4041;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}
</style>
